import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
} from "@mui/material";
import { ContainedButton, LoadingButton, TextButton } from "../../common/StyledButtons";
import Colors from "../../../constants/Colors";
import { STANDARD_PARAGRAPH_STYLE } from "../../../constants/Styles";
import StyledAvatarChipsTextField from "../../common/StyledAvatarChipTextField";
import { updateSiteContent } from "../../../actions/internal/SiteActions";
import { getUserId } from "../../../selectors/UserSelectors";

const EditContentDetailsModal = ({
  open,
  article,
  categories = [],
  onClose
}) => {

  const categoryOptionsRef = useRef([]);

  const [selectedCategories, setSelectedCategories] = useState([]);

  const [ isSaving, setIsSaving ] = useState(false);

  useEffect(() => {
    if (!categories || categories.length === 0) {
      categoryOptionsRef.current = [];
      setSelectedCategories([]);
      return;
    }
  
    const sorted = [...categories].sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  
    categoryOptionsRef.current = sorted;
  
    let selectedIds = [];
    if (article && article.wp_details && Array.isArray(article.wp_details.category_ids)) {
      selectedIds = article.wp_details.category_ids;
    }
  
    const selected = sorted.filter(c => selectedIds.includes(c.id));
    setSelectedCategories(selected);
  }, [categories, article]);
  

  const handleSave = async () => {
    try {
      setIsSaving(true);

      const { site_id, tracking_id } = article;
      const selectedIds = selectedCategories.map(s => s.id);
      await updateSiteContent(getUserId(), site_id, tracking_id, { category_ids: selectedIds });
      onClose();

    } catch (ex) {

    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Dialog
      fullWidth
      open={open}
      maxWidth={'sm'}
    >
        <DialogTitle>
            <h4 style={{ margin: 0, padding: 0 }}>Edit Content Details</h4>
        </DialogTitle>
        <DialogContent>
          <StyledAvatarChipsTextField 
                options={categoryOptionsRef.current}
                label="Category"
                onChange={(e, n) => { setSelectedCategories(n); }}
                value={selectedCategories}
                error={false}
                helperText={false ? 'Please select at least one category' : ''}
            />
        </DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', padding: '16px'}}>
            <Box>
                <TextButton sx={{ marginRight: '10px' }} onClick={onClose} disabled={isSaving}>Cancel</TextButton>
                <LoadingButton onClick={handleSave} isLoading={isSaving}>Update</LoadingButton>
            </Box>
        </Box>
    </Dialog>
  );
};

export default EditContentDetailsModal;
